import useAxios from "../../../../../../../context/AxiosContext/AxiosContext";
import { useAdministrationPanel } from "../../../../../AdministrationContext/AdministrationPanelContext";
import { useEffect, useState, useRef } from "react"
import { PhysycalPayment, PhysycalPaymentPhysicalPaymentComplete } from "../../../../../../../configurations/Axios/urls";

interface PaymentVoucher {
    headers: string[];
    data: any[];  // Puedes cambiar `any` por una interfaz específica si conoces la estructura de los datos
    totalSum: number;
    omitkeys: string[];
}

export interface UseContentPhysicalRegistrationReturn {
    alltransactionsactive: () => boolean;
    PayementsVouchers: PaymentVoucher;
    PayementsVouchersCompleted: PaymentVoucher;
    Pagination: (newPage: number) => void;
    makeRequest: () => void;
}

export interface physicalRegistration{
    user:string|null
}


const useContentPhysicalRegistration = ({user}:physicalRegistration): UseContentPhysicalRegistrationReturn  => {
    const { VisitaxGet } = useAxios();
    const { filter, urlsfiltered } = useAdministrationPanel();
    const hasInitialized = useRef(false);
    const hasRealyInitialized = useRef(false);
    const hasPageChanged = useRef(false);
    const registPerPage = 10;
    const alltransactionsactive = () => {
        if (filter === "today") return true;
        else return false;
    }
    const [currentPage, setCurrentPage] = useState(1)
    const Pagination = (newPage: number) => {
        if (currentPage === newPage) return;
        else {
            hasPageChanged.current = true;
            setCurrentPage(newPage);
        }
    }

    const [PayementsVouchers, setPaymentsVoucher] = useState({
        headers: ["Codigo de transacción", "Cantidad", "Descripción", "Usuario", "Fecha Cancun", "Fecha Mex"],
        data: [],
        totalSum: 0,
        omitkeys: ["id", "idTransaction", "lotClosing", "imageUrl", "idUser"]
    });

    const [PayementsVouchersCompleted, setPaymentsVoucherCompleted] = useState({
        headers: ["Codigo de transacción", "Cantidad", "Descripción", "Usuario", "Fecha Cancun", "Fecha Mex"],
        data: [],
        totalSum: 0,
        omitkeys: ["id", "idTransaction", "lotClosing", "imageUrl", "idUser"]
    });



    const ResetData = () => {
   
        setPaymentsVoucher({ ...PayementsVouchers, data: [], totalSum: 0 });
        setPaymentsVoucherCompleted({ ...PayementsVouchersCompleted, data: [], totalSum: 0 });
    }




    const getPhysicalCompleted = () => {
        const onPhysicalRecordCompletedRecived = (response: any) => {
            if (response.status == 200) {
                const Responsedata = response.data.data;
                if (Responsedata) {
                    setPaymentsVoucherCompleted({ ...PayementsVouchersCompleted, data: Responsedata, totalSum: Responsedata.length });
                }
                return;
            }
            setPaymentsVoucherCompleted({ ...PayementsVouchersCompleted, data: [], totalSum: 0 });

        }
        const usercomplement = user?"&idUser="+user:""
        const finalcomplementary = urlsfiltered.onlydates + "&PageNumber=" + currentPage + "&PageSize=" + registPerPage+usercomplement
        //  +user?"&idUser="+user:"";

        VisitaxGet(PhysycalPaymentPhysicalPaymentComplete + finalcomplementary, onPhysicalRecordCompletedRecived);
    }

    const getPhysicalRecord = () => {
        const onPhysicalRecordRecived = (response: any) => {
            if (response.status == 200) {
                const Responsedata = response.data.data;
                if (Responsedata) {
                    setPaymentsVoucher({ ...PayementsVouchers, data: Responsedata, totalSum: Responsedata.length });
                }
                return;
            }
            setPaymentsVoucher({ ...PayementsVouchers, data: [], totalSum: 0 });

        }
        const usercomplement = user?"&idUser="+user:""

        const finalcomplementary = urlsfiltered.onlydates + "&PageNumber=" + currentPage + "&PageSize=" + registPerPage+usercomplement
   
        VisitaxGet(PhysycalPayment + finalcomplementary, onPhysicalRecordRecived);
    }

    const makeRequest = () => {
        ResetData();
        // getLotClousures();
        getPhysicalCompleted();
        getPhysicalRecord();
    }

    useEffect(() => {
        if (hasInitialized.current) {
            makeRequest();
        }
    }, [urlsfiltered]);

    useEffect(() => {
        if (!hasInitialized.current && !hasRealyInitialized.current) {
            setTimeout(() => {
                hasInitialized.current = true;
            }, 500);
            hasRealyInitialized.current = true;
            makeRequest();
        }
    }, []);

    useEffect(() => {
        if (hasPageChanged.current) {
            getPhysicalCompleted();
        }
    }, [currentPage]);



    return ({
        alltransactionsactive,
        PayementsVouchers,
        PayementsVouchersCompleted,
        Pagination,
        makeRequest,
    })
}
export default useContentPhysicalRegistration